import { useEffect } from 'react';

import { getCrudTableSkeletonCountLocalStorageKey, useLocalStorage } from '@hooks/useLocalStorage';
import { ContentType } from '@models/Content';
import LayoutEntity from '@models/LayoutEntity';

const DEFAULT_SKELETON_COUNT = 10;

export default function useSkeletonCount<T extends LayoutEntity>(
  contentType: ContentType,
  items: T[]
) {
  const [skeletonCount, setSkeletonCount] = useLocalStorage(
    () => getCrudTableSkeletonCountLocalStorageKey(contentType),
    DEFAULT_SKELETON_COUNT
  );

  useEffect(() => {
    if (items.length > 0) setSkeletonCount(items.length);
  }, [items, setSkeletonCount]);

  return skeletonCount;
}
